
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.409 29.295C49.182 14.523 69.068 6 91.227 6h329.546c22.159 0 42.045 9.091 56.818 23.295 14.772 14.773 23.296 34.659 23.296 56.818v339.206c0 22.158-9.091 42.046-23.296 56.817-14.773 14.773-34.659 23.296-56.818 23.296H91.227V506c-22.158 0-42.045-9.091-56.817-23.295-14.772-14.772-23.296-34.66-23.296-56.818V86.113c-.001-22.158 9.091-42.045 23.295-56.818zm6.818 343.75v52.842c0 13.637 5.682 26.137 14.773 35.227 9.091 9.092 21.59 14.773 35.227 14.773h329.546c13.637 0 26.136-5.682 35.228-14.773 9.091-9.658 14.205-21.59 14.205-35.227v-71.024l-100.57-101.135-85.794 85.795c-5.683 5.683-15.342 5.683-21.592 0L135.545 212.25l-94.318 94.317v66.478zm0-109.09l83.522-84.092c5.683-5.681 15.341-6.25 21.592 0l126.705 127.272 85.795-85.794c5.682-5.682 15.341-6.25 21.591 0l89.773 90.34V86.113c0-13.636-5.114-25.568-14.205-34.659-9.092-9.091-21.591-14.773-35.228-14.773H91.227c-13.637 0-26.136 5.682-35.227 14.773-9.092 9.091-14.773 21.591-14.773 35.227v177.274z"}}),_c('circle',{attrs:{"cx":"299.637","cy":"156.127","r":"41.891"}})])
          )
        }
      }
    